

























































import { Component, PropSync, Ref, Vue } from 'vue-property-decorator';
import * as c_Interface from '@/interface/components/manageGroups';

@Component
export default class SwapMemberGroup extends Vue {
  @PropSync('ruleForm', { type: Object }) syncedRuleForm!: c_Interface.CreateGroupPayload;
  @PropSync('currentActive', { type: Number }) syncedCurrentActive!: number;

  @Ref('item') emailForm!: Array<HTMLFormElement>;

  public rules = {
    email: [
      { type: 'email', message: '정확한 이메일 주소를 입력해주세요.', trigger: ['blur', 'change'] },
    ],
  };
  public isValidate = true;

  addMember(): void {
    this.syncedRuleForm.members.push({
      email: '',
      isAdmin: false,
    });
  }

  async toNextStep() {
    await this.validateAll();
    if (this.isValidate) {
      this.syncedCurrentActive++;
    } else {
      this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
    }
  }

  validateAll(): void {
    let validationCount: number = 0;

    for (let i = 0; i < this.syncedRuleForm.members.length; i += 1) {
      this.emailForm[i].validate((valid: boolean) => {
        if (!valid) {
          this.isValidate = false;
        } else validationCount += 1;
      });
    }

    if (validationCount === this.syncedRuleForm.members.length) this.isValidate = true;
  }

  modalClose() {
    this.$root.$emit('closeCreateLab', false);
  }

  deleteMember(item: any): void {
    this.syncedRuleForm.members.splice(this.syncedRuleForm.members.indexOf(item), 1);
  }
}
